var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.4527,
    cy: 29.4576,
    r: 27.6327,
    transform: "rotate(180 29.4527 29.4576)",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5628 15.1283C26.8687 15.1273 27.1709 15.194 27.4473 15.3236C27.7237 15.4532 27.9672 15.6423 28.16 15.8771L38.0503 28.0186C38.3515 28.3807 38.5161 28.8349 38.5161 29.3036C38.5161 29.7723 38.3515 30.2265 38.0503 30.5886L27.8119 42.7302C27.4643 43.1434 26.9648 43.4033 26.4234 43.4526C25.8819 43.502 25.3428 43.3367 24.9246 42.9932C24.5065 42.6497 24.2435 42.1562 24.1936 41.6211C24.1436 41.086 24.3109 40.5532 24.6584 40.14L33.8116 29.2935L24.9656 18.447C24.7152 18.15 24.5561 17.7883 24.5072 17.4047C24.4583 17.0211 24.5216 16.6318 24.6897 16.2826C24.8577 15.9335 25.1234 15.6393 25.4553 15.4347C25.7873 15.2301 26.1716 15.1238 26.5628 15.1283Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.b1f1bc1a685a3192b80f1e0ffdf152bc.svg";
export { ForwardRef as ReactComponent };